import { AssessmentOverviewFormField } from '../sections/assessment-overview/formField'
import { PatientOverviewFormField } from '../sections/patient-overview/formField'
import { SupervisoryReviewFormField } from '../sections/supervisory-review/formField'
import { FinalStepsFormField } from '../sections/final-steps/formField'

// Amalgamate all section form field enums
export const SupervisoryFormField = {
  ...AssessmentOverviewFormField,
  ...PatientOverviewFormField,
  ...SupervisoryReviewFormField,
  ...FinalStepsFormField
} as const

export type SupervisoryFormField = (typeof SupervisoryFormField)[keyof typeof SupervisoryFormField]
